export default __webpack_public_path__ + "static/media/review.0df76745.png";